<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6">
        <lib-page-header-light page-title="AUDESP - FASE 4" fa-icon="file-signature"></lib-page-header-light>
      </div>
      <div class="col-md-6">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <a class="btn btn-outline-primary btn-sm float-right ml-2" data-toggle="modal"
          data-target="#dialogAudespPacoteList" title="Consultar Pacotes">
          <i class="fa fa-box"></i>
        </a>
        <a *ngIf="tipoFiltro !== '*' && podeIncluir()" (click)="iniciarPacote()"
          class="btn btn-sm btn-primary float-right ml-2">
          <i class="fa fa-arrow-down"></i> Exportar Pacotes
        </a>
        <a *ngIf="(tipoFiltro === '*' || tipoFiltro === 'LIC_REG_SIM' || tipoFiltro === 'LIC_REG_NAO1' || tipoFiltro === 'LIC_REG_NAO2' || tipoFiltro === 'LIC_REG_NAO3') && podeIncluir()"
          [routerLink]="['/licitacoes-audesp/novo']" class="btn btn-sm btn-outline-success float-right">
          <i class="fa fa-plus"></i> Novo
        </a>
      </div>
    </div>
    <hr class="mt-1" />
    <div class="row">
      <div class="col-md-9 p-0" style="border-left: 1px solid #dee2e6;">
        <div class="table-responsive" style="height: calc(100vh - 180px); overflow-y: auto; overflow-x: hidden;">
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === '*'">
            <thead>
              <tr>
                <th scope="col" style="width: 120px;" class="text-center">Código</th>
                <th scope="col" style="width: 90px;" class="text-center">Tipo</th>
                <th scope="col" style="width: 80px;" class="text-center">Licitação</th>
                <th scope="col" style="width: 80px;" class="text-center">Processo</th>
                <th scope="col">Modalidade</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 45px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <th scope="row" class="text-center">
                  {{item.codigo}}
                </th>
                <td class="text-center">
                  <span class="badge badge-secondary">{{item.tipo}}</span>
                </td>
                <td class="text-center">
                  <a [routerLink]="['/licitacoes', item.licitacao.id, 'editar']" class="btn btn-sm btn-link p-0"
                    target="_blank">
                    {{item.licitacao.numero | LICITACAO}}
                  </a>
                </td>
                <td class="text-center">{{item.licitacao.processo | LICITACAO}}</td>
                <td>{{item.licitacao.modalidade.nome}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.exportado ? ' text-primary' : '')"
                    [title]="(item.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.enviado ? ' text-primary' : '')"
                    [title]="(item.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.armazenado ? ' text-success' : '')"
                    [title]="(item.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button [routerLink]="['/licitacoes-audesp', item.id, 'editar']" routerLinkActive="router-link-active"
                    class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm"
            *ngIf="tipoFiltro === 'LIC_REG_SIM' || tipoFiltro === 'LIC_REG_NAO1' || tipoFiltro === 'LIC_REG_NAO2' || tipoFiltro === 'LIC_REG_NAO3'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 110px;" class="text-center">Código</th>
                <th scope="col" style="width: 80px;" class="text-center">Licitação</th>
                <th scope="col" style="width: 80px;" class="text-center">Processo</th>
                <th scope="col">Modalidade</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="width: 100px;" class="text-center">Situação</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 40px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.licitacao_audesp && !item.licitacao_audesp.armazenado">
                </td>
                <th scope="row" class="text-center">
                  {{item.licitacao_audesp?.codigo}}
                </th>
                <td class="text-center">
                  <a [routerLink]="['/licitacoes', item.id, 'editar']" class="btn btn-sm btn-link p-0" target="_blank">
                    {{item.numero | LICITACAO}}
                  </a>
                </td>
                <td class="text-center">{{item.processo | LICITACAO}}</td>
                <td>{{item.modalidade?.nome}}</td>
                <td class="text-center">
                  {{item.data_homologacao | date:'dd/MM/yy':'GMT'}}
                </td>
                <td class="text-center">
                  {{item.situacao}}
                </td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button *ngIf="item.licitacao_audesp"
                    [routerLink]="['/licitacoes-audesp', item.licitacao_audesp.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="!item.licitacao_audesp" [routerLink]="['/licitacoes-audesp', 'novo', item.id]"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm"
            *ngIf="tipoFiltro === 'AJUSTE_CONTRATO' || tipoFiltro === 'TERMO_ADITIVO'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 110px;" class="text-center">Código</th>
                <th scope="col" style="width: 90px;" class="text-center">Contrato</th>
                <th scope="col">Beneficiário</th>
                <th scope="col" style="width: 60px;" class="text-center">Início</th>
                <th scope="col" style="width: 60px;" class="text-center">Término</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 40px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.licitacao_audesp && !item.licitacao_audesp.armazenado">
                </td>
                <th scope="row" class="text-center">
                  {{item.licitacao_audesp?.codigo}}
                </th>
                <td class="text-center">
                  <a [routerLink]="['/contratos', item.id, 'editar']" class="btn btn-sm btn-link p-0" target="_blank">
                    {{item.numero | LICITACAO}} <span *ngIf="item.aditivo > 0">{{item.aditivo}}</span>
                  </a>
                </td>
                <td>{{item.favorecido?.nome}}</td>
                <td class="text-center">{{item.data_inicio | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-center">{{item.data_termino | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button *ngIf="item.licitacao_audesp"
                    [routerLink]="['/licitacoes-audesp', item.licitacao.licitacao_audesp.id, 'ajuste', item.licitacao_audesp.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="!item.licitacao_audesp && item.licitacao?.licitacao_audesp?.armazenado"
                    [routerLink]="['/licitacoes-audesp', item.licitacao.licitacao_audesp.id, 'ajuste', 'novo', item.id]"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === 'EMPENHO'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 50px;" class="text-center">Empenho</th>
                <th scope="col" style="width: 80px;" class="text-center">Contrato</th>
                <th scope="col">Beneficiário</th>
                <th scope="col">Recurso</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="width: 60px;" class="text-right">Valor</th>
                <th scope="col" style="width: 70px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.contrato?.licitacao_audesp?.exportado && !item.licitacao_audesp?.armazenado">
                </td>
                <th class="text-center">
                  {{("00000" + item.numero).slice(-5)}}
                </th>
                <td class="text-center">
                  {{item.contrato?.numero | LICITACAO}}
                </td>
                <td>{{item.favorecido?.nome}}</td>
                <td>{{item.ficha?.recurso?.codigo}} - {{item.ficha?.recurso?.nome}}</td>
                <td class="text-center">{{item.data_empenho | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-right">{{item.valor_empenho | number:'1.2-2'}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === 'EXIGENCIA_OBRAS'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 110px;" class="text-center">Ajuste</th>
                <th scope="col" style="width: 80px;" class="text-center">Contrato</th>
                <th scope="col" style="width: 80px;" class="text-center">Licitação</th>
                <th scope="col" style="width: 80px;" class="text-center">Processo</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col">Modalidade</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 40px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.licitacao_audesp_obra && !item.licitacao_audesp_obra.armazenado">
                </td>
                <th scope="row" class="text-center">
                  {{item.licitacao_audesp_obra?.codigo}}
                </th>
                <td class="text-center">
                  <a [routerLink]="['/contratos', item.id, 'editar']" class="btn btn-sm btn-link p-0" target="_blank">
                    {{item.numero | LICITACAO}}
                  </a>
                </td>
                <td class="text-center">
                  <a [routerLink]="['/licitacoes', item.licitacao.id, 'editar']" class="btn btn-sm btn-link p-0"
                    target="_blank" *ngIf="item.licitacao">
                    {{item.licitacao?.numero | LICITACAO}}
                  </a>
                </td>
                <td class="text-center">{{item.licitacao?.processo | LICITACAO}}</td>
                <td class="text-center">
                  {{item.licitacao?.data_homologacao | date:'dd/MM/yy':'GMT'}}
                </td>
                <td>{{item.licitacao?.modalidade?.nome}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp_obra?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp_obra?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp_obra?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp_obra?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp_obra?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp_obra?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button *ngIf="item.licitacao_audesp_obra"
                    [routerLink]="['/licitacoes-audesp', item.licitacao.licitacao_audesp.id, item.licitacao_audesp.id, 'exigencia-obras',  item.licitacao_audesp_obra.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="!item.licitacao_audesp_obra && item.licitacao_audesp?.armazenado"
                    [routerLink]="['/licitacoes-audesp', item.licitacao.licitacao_audesp.id, item.licitacao_audesp.id, 'exigencia-obras', 'novo']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === 'EXECUCAO'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 130px;" class="text-center">Ajuste</th>
                <th scope="col" style="width: 50px;" class="text-center">Emp.</th>
                <th scope="col" style="width: 80px;" class="text-center">Contrato</th>
                <th scope="col">Beneficiário</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="width: 60px;" class="text-right">Valor</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 40px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.licitacao_audesp_execucao && !item.licitacao_audesp_execucao.armazenado">
                </td>
                <th scope="row" class="text-center">
                  <i *ngIf="item.licitacao_audesp_execucao" class="fa fa-info-circle text-primary"
                    [title]="item.licitacao_audesp_execucao.identificacao"></i>
                  {{item.licitacao_audesp_execucao?.codigo}}
                </th>
                <td class="text-center">
                  {{("00000" + item.numero).slice(-5)}}
                </td>
                <td class="text-center">
                  {{item.contrato?.numero | LICITACAO}}
                </td>
                <td>{{item.favorecido?.nome}}</td>
                <td class="text-center">{{item.data_empenho | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-right">{{item.valor_empenho | number:'1.2-2'}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp_execucao?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp_execucao?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp_execucao?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp_execucao?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp_execucao?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp_execucao?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button *ngIf="item.licitacao_audesp_execucao"
                    [routerLink]="['/licitacoes-audesp', item.contrato.licitacao.licitacao_audesp.id, item.contrato.licitacao_audesp.id, 'execucao',  item.licitacao_audesp_execucao.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="!item.licitacao_audesp_execucao && item.contrato?.licitacao_audesp?.armazenado"
                    [routerLink]="['/licitacoes-audesp', item.contrato.licitacao.licitacao_audesp.id, item.contrato.licitacao_audesp.id, 'execucao', 'novo', item.id]"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === 'DOC_FISCAL'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px;" class="text-center">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th scope="col" style="width: 130px;" class="text-center">Ajuste</th>
                <th scope="col" style="width: 50px;" class="text-center">Empenho</th>
                <th scope="col" style="width: 80px;" class="text-center">Data</th>
                <th scope="col">Documento</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="width: 60px;" class="text-right">Valor</th>
                <th scope="col" style="width: 70px;"></th>
                <th scope="col" style="width: 40px;" *ngIf="podeIncluir()"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.empenho?.licitacao_audesp_execucao?.exportado && !item.licitacao_audesp?.armazenado">
                </td>
                <th scope="row" class="text-center">
                  <i *ngIf="item.licitacao_audesp" class="fa fa-info-circle text-primary"
                    [title]="item.licitacao_audesp.identificacao"></i>
                  {{item.licitacao_audesp?.codigo}}
                </th>
                <td class="text-center">
                  {{("00000" + item.empenho?.numero).slice(-5)}}
                </td>
                <td class="text-center">{{item.empenho?.data_empenho | date:'dd/MM/yy':'GMT'}}</td>
                <td>{{item.documento}}</td>
                <td class="text-center">{{item.data_liquidacao | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-right">{{item.valor_liquidado | number:'1.2-2'}}</td>
                <td class="text-muted" style="font-size: 1.2rem">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
                <td class="text-right" *ngIf="podeIncluir()">
                  <button *ngIf="item.licitacao_audesp"
                    [routerLink]="['/licitacoes-audesp', item.empenho.licitacao_audesp_execucao.parente.id, item.empenho.licitacao_audesp_execucao.id, 'documento-fiscal', item.licitacao_audesp.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="!item.licitacao_audesp && item.empenho?.licitacao_audesp_execucao"
                    [routerLink]="['/licitacoes-audesp', item.empenho.licitacao_audesp_execucao.parente.id, item.empenho.licitacao_audesp_execucao.id, 'documento-fiscal', 'novo']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-eddy table-sm" *ngIf="tipoFiltro === 'PAGAMENTO'">
            <thead>
              <tr>
                <th scope="col" style="width: 25px; border-right: 1px solid #dee2e6;" class="text-center" rowspan="2">
                  <input type="checkbox" [(ngModel)]="marcado" (click)="toggleSelecionado()">
                </th>
                <th class="text-center" colspan="2">Empenho</th>
                <th class="text-center" colspan="3" style="border-left: 1px solid #dee2e6;">Liquidação</th>
                <th class="text-center" colspan="4" style="border-left: 1px solid #dee2e6;">Pagamento</th>
                <th scope="col" style="width: 70px; border-left: 1px solid #dee2e6;" rowspan="2"></th>
              </tr>
              <tr>
                <th scope="col" style="width: 50px;" class="text-center">Número</th>
                <th scope="col" style="width: 80px;" class="text-center">Data</th>
                <th scope="col" style="border-left: 1px solid #dee2e6;">Documento</th>
                <th scope="col" style="width: 50px;" class="text-center">Parcela</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="border-left: 1px solid #dee2e6;">Documento</th>
                <th scope="col" style="width: 60px;" class="text-center">Data</th>
                <th scope="col" style="width: 60px;" class="text-right">Valor</th>
                <th scope="col" style="width: 60px;" class="text-center">Encargos</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center" style="border-right: 1px solid #dee2e6;">
                  <input type="checkbox" [(ngModel)]="item.selecionado" [checked]="item.selecionado"
                    *ngIf="item.liquidacao?.licitacao_audesp?.exportado && !item.licitacao_audesp?.armazenado">
                </td>
                <th class="text-center">
                  {{("00000" + item.liquidacao?.empenho?.numero).slice(-5)}}
                </th>
                <td class="text-center">{{item.liquidacao?.empenho?.data_empenho | date:'dd/MM/yy':'GMT'}}</td>
                <td style="border-left: 1px solid #dee2e6;">{{item.liquidacao?.documento}}</td>
                <td scope="row" class="text-center">
                  <span *ngIf="item.liquidacao.parcela > 0">{{("00" + item.liquidacao.parcela).slice(-2) }}</span>
                  <span *ngIf="item.liquidacao.parcela === 0">-</span>
                </td>
                <td class="text-center">{{item.liquidacao?.data_liquidacao | date:'dd/MM/yy':'GMT'}}</td>
                <td style="border-left: 1px solid #dee2e6;">{{item.documento}}</td>
                <td class="text-center">{{item.data_pagamento | date:'dd/MM/yy':'GMT'}}</td>
                <td class="text-right">{{item.valor_pago | number:'1.2-2'}}</td>
                <td class="text-right"></td>
                <td class="text-muted" style="font-size: 1.2rem; border-left: 1px solid #dee2e6;">
                  <i [class]="'fa fa-arrow-circle-down' + (item.licitacao_audesp?.exportado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.exportado ? '' : 'Não ') + 'Exportado'"></i>
                  <i [class]="'fa fa-arrow-circle-up' + (item.licitacao_audesp?.enviado ? ' text-primary' : '')"
                    [title]="(item.licitacao_audesp?.enviado ? '' : 'Não ') + 'Enviado'"></i>
                  <i [class]="'fa fa-check-circle' + (item.licitacao_audesp?.armazenado ? ' text-success' : '')"
                    [title]="(item.licitacao_audesp?.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row float-right" *ngIf="lista && lista.length > 0">
          <div class="col-12">
            <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
              (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
          </div>
        </div>
      </div>
      <div class="col-md-3 pr-0" style="border-left: 1px solid #dee2e6;">
        <p-fieldset legend="Filtros">
          <div class="row">
            <div class="col-12">
              <label for="tipoFiltro" class="font-weight-bold">Tipo de Busca</label>
              <select [compareWith]="compareFn" [(ngModel)]="tipoFiltro" [ngModelOptions]="{standalone: true}"
                id="tipoFiltro" class="form-control" (change)="trocarTipo()">
                <option *ngFor="let item of listaTipoFiltro" [value]="item.id" [disabled]="item.id === '_'"
                  [class]="(item.id === '_' ? 'small text-muted' : '')">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <hr />
          <div class="row" *ngIf="tipoFiltro !== '*'">
            <div class="col-12">
              <label for="filtroData" class="font-weight-bold d-block">Intervalo de Datas</label>
              <p-calendar id="filtroData" [(ngModel)]="filtroData" [ngModelOptions]="{standalone: true}"
                inputStyleClass="form-control" [showOnFocus]="true" selectionMode="range" dateFormat="dd/mm/yy">
              </p-calendar>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <input [(ngModel)]="filtro" (keydown.enter)="atualizarListagem()" type="text" class="form-control"
                placeholder="Busca geral" aria-label="Busca geral">
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6">
              <button class="btn btn-sm btn-link" (click)="iniciarFiltros()">Limpar</button>
            </div>
            <div class="col-6">
              <button class="btn btn-sm btn-primary float-right" (click)="atualizarListagem()">Buscar</button>
            </div>
          </div>
        </p-fieldset>
        <p-fieldset legend="Legendas">
          <div class="row text-muted">
            <div class="col-12">
              <i class="fa fa-arrow-circle-down text-primary"></i> Exportado
            </div>
            <div class="col-12">
              <i class="fa fa-arrow-circle-up text-primary"></i> Enviado
            </div>
            <div class="col-12">
              <i class="fa fa-check-circle text-success"></i> Armazenado
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogFase4Pacote" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        AUDESP - FASE 4 [Geração de pacotes]
      </div>
      <div class="modal-body">
        <table class="table table-eddy table-sm" *ngIf="tipoFiltro !== '*'">
          <thead>
            <tr>
              <th scope="col" style="width: 110px;" class="text-center">Código</th>
              <th scope="col">Identificação</th>
              <th scope="col" style="width: 85px;" class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaAudesp">
              <th scope="row" class="text-center">
                <a [routerLink]="['/licitacoes-audesp', item.id, 'editar']" class="btn btn-sm btn-link p-0"
                  target="_blank">
                  {{item.codigo}}
                </a>
              </th>
              <td>{{item.identificacao}}
                <a class="btn btn-link btn-sm text-danger float-right p-0" (click)="visualizarInconsistencias(item)"
                  *ngIf="item.mensagemXML">
                  Visualizar Inconsistências
                </a>
              </td>
              <td class="text-center">
                <span *ngIf="item.valido === undefined">
                  <i class="fa fa-clock text-muted"></i> Pendente
                </span>
                <span *ngIf="item.valido === false">
                  <i class="fa fa-times text-danger"></i> Inválido
                </span>
                <span *ngIf="item.valido">
                  <i class="fa fa-check text-success"></i> Válido
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <div class="row">
          <button type="button" class="btn btn-link col-auto" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary col-auto" *ngIf="!arquivosValidos"
            (click)="validarRegistros()">Validar Registros</button>
          <button type="button" class="btn btn-primary col-auto" *ngIf="arquivosValidos" (click)="gerarPacotes()">Gerar
            Pacote</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogMensagensXML" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        Inconsistências do Registro
      </div>
      <div class="modal-body p-1">
        <ul class="list-group list-group-flush text-muted">
          <li class="list-group-item p-1" *ngFor="let msg of itemInvalido?.mensagemXML" style="border-style: dashed">
            {{msg}}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-sm text-muted" data-dismiss="modal">Fechar</button>
        <a class="btn btn-sm btn-danger" target="_blank"
          [routerLink]="['/licitacoes-audesp', itemInvalido?.id, 'editar']">Ajustar Registro</a>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogMensagensXMLPacote" tabindex="-1" role="dialog" 
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        Inconsistências do Pacote
      </div>
      <div class="modal-body p-1">
        <ul class="list-group list-group-flush text-muted">
          <li class="list-group-item p-1" *ngFor="let msg of mensagemXML" style="border-style: dashed">
            {{msg}}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-sm text-danger" (click)="baixarXMLInvalido()"
          *ngIf="xmlInvalido">Baixar XML</button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
<lib-licitacao-audesp-pacote></lib-licitacao-audesp-pacote>